<template>
  <div class="slider">
    <BaseImage class="slider-item" v-for="(image, index) in images" :key="index" :image="image.url_image" />
  </div>
</template>

<script>
export default {
  name: 'BaseSlider',
  props: {
    images: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .slider {
    display: flex;
  }
</style>
